<template>
  <div id="live-streaming">
    <div class="livewrap">
      <div class="livewrap__inner">
        <div class="account">
          <router-link
            class="account__link__wrap"
            :to="`/performer/${performerId}`"
          >
            <div class="account__thumbnail">
              <img
                :src="$store.state.performer.photoURL"
                width="36"
                height="36"
                alt=""
              />
            </div>
            <div class="account__name">
              {{ $store.state.performer.nickname }}
            </div>
          </router-link>
          <div class="account__favorite" @click="onClickLike">
            <b-icon :icon="liked ? `heart` : `heart-outline`" size="is-small">
            </b-icon>
          </div>
        </div>
        <div class="columns">
          <div class="column video">
            <div class="video__wrap">
              <div class="video__wrap__inner">
                <Video :liveUrl="playbackUrl" />
              </div>
            </div>
          </div>
          <div class="column is-one-third-desktop video__text">
            <div class="comment">
              <div class="comment__display">
                <div
                  class="media"
                  v-for="(comment, index) in comments"
                  :key="index"
                >
                  <figure class="media-left">
                    <div class="image">
                      <b-image
                        :src="comment.photoURL"
                        ratio="1by1"
                        :rounded="true"
                      />
                    </div>
                  </figure>
                  <div v-if="comment.type == 'comment'" class="media-content">
                    <div class="content">
                      <p>
                        <strong>{{ comment.nickname }}</strong>
                        <br />
                        {{ comment.message }}
                        <br />
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="comment.type == 'gift'"
                    class="media-content gift-content"
                  >
                    <div class="content">
                      <strong>{{ comment.nickname }}</strong>
                      <br />
                      <figure class="gift-icon-container">
                        <img :src="comment.iconURL" class="gift-icon" />
                      </figure>
                      <p class="gift-message">
                        "{{ comment.giftNameJP }}"が届きました！
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="comment__input">
                <b-field>
                  <b-input
                    placeholder="コメントを書いてください"
                    v-model="comment"
                    expanded
                    @keydown.native.enter="onClickComment"
                  >
                  </b-input>
                  <p class="control">
                    <b-button
                      type="is-primary"
                      label="送信"
                      @click="onClickComment"
                    />
                  </p>
                </b-field>
              </div>
            </div>
            <div class="gift">
              <b-button
                icon-left="gift"
                @click="onClickSendGift"
                rounded
                expanded
                ><span class="is-hidden-mobile">ギフトを贈る</span></b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
import * as userServices from '@/services/userServices';
import Video from '@/components/Video';
import moment from 'moment';
import LiveStreamingSendGiftModal from '@/components/LiveStreamingSendGiftModal';

export default {
  name: 'LiveStreaming',
  components: {
    Video
  },
  computed: {
    playbackUrl() {
      return this.$store.getters['live/playbackUrl'];
    }
  },
  data() {
    return {
      // TODO: fetch this from firebase
      liked: false,
      comment: '',
      comments: [],
      commentRefObj: {},
      item: {},
      performerId: ''
    };
  },
  updated() {
    this.scrollToEnd();
  },
  async created() {
    // TODO: reject to access if no liveId
    await this.$store.dispatch(
      'live/loadRecentLive',
      this.$route.params.liveId
    );
    this.performerId = this.$store.state.live.recentLive.userId;

    // Setup comment reference
    this.commentRefObj = await liveServices.getLiveCommentRefObj(
      this.$route.params.liveId
    );
    let that = this;
    this.commentRefObj
      .orderByChild('timestamp')
      .limitToLast(100)
      .on('child_added', function (snap) {
        that.comments.push(snap.val());
        if (that.comments.length > 100) that.comments.splice(0, 1);
      });

    // Load performer data
    await this.$store.dispatch('performer/loadPerformerDoc', this.performerId);
    this.liked = await userServices.performerIsLiked(
      this.$store.state.auth.uid,
      this.performerId
    );
  },
  methods: {
    scrollToEnd() {
      const container = document.querySelector('.comment__display');
      container.scrollTop = container.scrollHeight;
    },
    onClickSendGift() {
      this.$buefy.modal.open({
        parent: this,
        component: LiveStreamingSendGiftModal,
        hasModalCard: true,
        trapFocus: true,
        props: {
          commentRefObj: this.commentRefObj
        }
      });
    },
    async onClickLike() {
      if (this.liked) {
        try {
          const payload = {
            userId: this.$store.state.auth.uid,
            performerIds: [this.performerId]
          };
          await this.$store.dispatch('user/removePerformersFromLiked', payload);
          this.liked = false;
        } catch (err) {
          console.error(err);
          return;
        }
      } else {
        try {
          await userServices.addLikedPerformer(this.$store.state.auth.uid, {
            performerId: this.performerId,
            nickname: this.$store.state.performer.nickname,
            photoURL: this.$store.state.performer.photoURL
          });
          this.liked = true;
        } catch (err) {
          console.error(err);
          return;
        }
      }
    },
    async onClickComment() {
      if (this.comment == '') return;
      const payload = {
        userId: this.$store.state.auth.uid,
        nickname: this.$store.state.user.nickname,
        photoURL: this.$store.state.user.photoURL,
        message: this.comment,
        type: 'comment',
        timestamp: moment().unix()
      };
      this.comment = '';
      let newMessageRef = this.commentRefObj.push();
      newMessageRef.set(payload);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-streaming.scss';
</style>
